// Centralized config for environment variables
// Add more as needed

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
export const AUTH_URL = process.env.REACT_APP_AUTH_URL

// For EC2 reverse proxy
//export const API_BASE_URL='/api';
//export const AUTH_URL='/auth';

// For local development
//export const API_BASE_URL='http://localhost:8080';
//export const AUTH_URL='http://localhost:8000';
